export default "__VITE_ASSET__7bce644f__"